export class ScrollIf implements ng.IDirective {
    restrict = 'A';
    scope: {
        scrollIf: '='
    };

    link: (scope: angular.IScope, element: angular.IAugmentedJQuery, attrs: angular.IAttributes) => any;

    constructor() {
        this.link = (scope: ng.IScope, element: ng.IAugmentedJQuery,
                     attrs: ng.IAttributes) => {
            scope.$watch(attrs.scrollIf, function (value) {
                if (value) {
                    const elem = element[0];

                    if (elem instanceof HTMLElement) {
                        const isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;
                        if(isSmoothScrollSupported) {
                            elem.scrollIntoView(<any> {behavior: "smooth", block: "center"});
                        } else {
                            elem.scrollIntoView(true);
                        }
                    }
                }
            });
        }
    }

    static factory(): ng.IDirectiveFactory {
        const directive = () => new ScrollIf();
        directive.$inject = [];
        return directive;
    }
}